import React from 'react'
import {Link} from "gatsby"
import Title from "../global/Title"

export default function Profile() {
    return (
      
            <div className="container-fluid test py-4">
                <div className="row">
                    <div className="col-sm-10 mx-auto">
                        <ul className="profileList">
                            <li className="py-2">Promoted by Shri K.A.Palaniappan and his three sons in 1985 at Tiruchirapalli, we started manufacturing metal articles for domestic & industrial kitchens, large canteens, worship places, government free schemes, etc.,. </li>
                            <li className="py-2">By 1992, the business moved to Chennai, to become contract manufactures of original components of kitchen appliances for the leading brands of South India, namely, Butterfly, Premier, Prestige, Preethi, etc.,. </li>
                            <li className="py-2">By 2000, the business ventured into contract manufacturing the finished kitchen hobs (LPG Stoves) to major brand owners. By 2008, the business ventured into national market, by setting up the plant near Baddi, Himachal Pradesh to leverage the tax holiday schemes by the central government.</li>
                            <li className="py-2">Backed with more than 3 decades of manufacturing experience, customer friendly and ethical business policies, the promoters have immense confidence to get this business to the top line ranks nationally.  </li>
                        </ul>
                    </div>
                </div>
            </div>

   
    )
}

